module.exports = __webpack_public_path__ + "img/BSpace.2b711a68.png";